import { useMutation } from "@tanstack/react-query";
import { discountService } from "..";
import { CalculateCustomerGroupDiscountSmsAmountPayload } from "../type";

type Props = {
  setAmount?: (e: number) => void;
  setOpenAmount: () => void;
  setSmsCount?: (e: number) => void;
};

function useCalculateDiscountCustomerGroupIdAmount({
  setAmount,
  setOpenAmount,
  setSmsCount,
}: Props) {
  return useMutation({
    mutationFn: (command: CalculateCustomerGroupDiscountSmsAmountPayload) => {
      return discountService.calculateDiscountByCustomerGroupAmount(command);
    },
    onSuccess(data) {
      if (setAmount) setAmount(data?.sumAmount || 0);
      if (setSmsCount) setSmsCount(data?.smsCount || 0);
      setOpenAmount();
    },
  });
}

export default useCalculateDiscountCustomerGroupIdAmount;
